export default {
  background: {
    default: '#FFFFFF',
    paper: '#ffffff'
  },
  primary: {
    light: '#0F62FE33',
    main: '#ABB8A1',
    dark: '#0F62FE33',
    contrastText: '#ffffff'
  },
  secondary: {
    light: '#a5a5a5ff',
    main: '#E9B992',
    dark: '#000000ff',
    contrastText: '#ffffff'
  },
  error: {
    light: '#B20000',
    main: '#B20000',
    dark: '#B20000',
    contrastText: '#ffffff'
  },
  text: {
    primary: '#000000',
    secondary: '#636569',
    disabled: '#96989C',
    content: '#424242',
    contrast: '#ffffff'
  },
  info: {
    light: '#E7EFFF',
    main: '#0F62FE',
    dark: '#093CAD',
    contrastText: '#ffffff'
  },
  success: {
    light: '#59B960',
    main: '#59B960',
    dark: '#59B960',
    contrastText: '#ffffff'
  },
  warning: {
    light: '#f06f34',
    main: '#f06f34',
    dark: '#f06f34',
    contrastText: '#ffffff'
  },
  action: {
    selected: 'rgba(57, 90, 139, 1)',
    disabled: '#BDBDBD',
    hover: '#ABB8A1',
    hoverOpacity: 0.1
  },
  grey: {
    50: '#ffffff',
    100: '#FAFAFA',
    200: '#f2f2f2',
    300: '#f0f0f0',
    400: '#D9D9D9',
    500: '#F5F5F5',
    600: '#dfdfdf',
    700: '#F1F3F5',
    800: '#4B4C4E',
    900: '#EAEAEB',
    A400: '#e9e9e9',
    A700: '#000000'
  }
};
